// Firebase Configuration
export const firebaseConfig = {
  apiKey: "AIzaSyAUNdG9BqJ0AMpZTQ4i1BBrO_yaeJtrwBs",
  authDomain: "beatsofwashington-a760b.firebaseapp.com",
  projectId: "beatsofwashington-a760b",
  storageBucket: "beatsofwashington-a760b.firebasestorage.app",
  messagingSenderId: "713875891450",
  appId: "1:713875891450:web:492ceb6a966d6532b6d543"
};
